import { useEffect, useState } from 'react'
import { adminService } from 'core/services/adminService'
import { MarketingItem } from './marketing-item'
import { MarketingEdit } from './marketing-edit'

import c from './assets/sass/marketing-list.module.scss'

export const MarketingList = () => {
    const [campaigns, setCampaigns] = useState([])
    const [loading, setLoading] = useState(true)
    const [editing, setEditing] = useState(null)
    const [creating, setCreating] = useState(false)

    useEffect(() => {
        loadCampaigns()
    }, [])

    const loadCampaigns = async () => {
        try {
            const data = await adminService.getMarketingCampaigns()
            setCampaigns(data.campaigns)
        } catch (error) {
            console.error('Failed to load campaigns:', error)
        } finally {
            setLoading(false)
        }
    }

    const handleEdit = (campaign) => {
        setEditing(campaign)
        setCreating(false)
    }

    const handleCreate = () => {
        setCreating(true)
        setEditing(null)
    }

    const handleSave = async () => {
        await loadCampaigns()
        setEditing(null)
        setCreating(false)
    }

    const handleCancel = () => {
        setEditing(null)
        setCreating(false)
    }

    if (loading) {
        return <div className={c.loading}>Загрузка...</div>
    }

    if (editing || creating) {
        return (
            <MarketingEdit
                campaignData={editing}
                onSave={handleSave}
                onCancel={handleCancel}
            />
        )
    }

    return (
        <div className={c.component}>
            <button className={c.createBtn} onClick={handleCreate}>
                + Создать кампанию
            </button>
            <div className={c.list}>
                {campaigns.map((campaign) => (
                    <MarketingItem
                        key={campaign.id}
                        campaign={campaign}
                        onEdit={() => handleEdit(campaign)}
                        onUpdate={loadCampaigns}
                    />
                ))}
            </div>
        </div>
    )
}
